import { StateCreator } from "zustand";
import { ICart } from "../../constants/types";
import type { TransaksiStore } from "../transaksiStore";

export interface CartSlice {
    cart: ICart[];
    maxItem: boolean;
    addToCart: (data: ICart) => void;
    handleUpdate: (data: ICart) => void;
    handleUpdateByBarcode: (data: ICart) => void;
    handleRemove: (data: ICart) => void;
    handleFaktur: (id: number, faktur: ICart["faktur"]) => void;
    handleFakturBundling: (
        idBundling: number,
        newFaktur: ICart["faktur"],
        idSatuan: number,
    ) => void;
    resetCart: () => void;
    handlerErrorMaxItem: () => void;
    resetErrorMaxItem: () => void;
    handleReset: () => void;
}

export const createCartSlice: StateCreator<
    TransaksiStore,
    [],
    [],
    CartSlice
> = (set, get) => ({
    cart: [],
    maxItem: false,
    addToCart: (data) => {
        const { cart, handlerErrorMaxItem } = get();
        const selectedCart = cart.filter((li) => li.id === data.id);
        if (selectedCart.length > 0) {
            const newCart = [...cart];
            const index = cart.findIndex((c) => c.id === data.id);
            newCart[index] = { ...data, qty: cart[index].qty + 1 };

            const isBundling = Number(data?.detailBundling.length) > 0;
            if (isBundling) {
                const bundling = data?.detailBundling;
                const indexes: number[] = [];
                bundling?.forEach((bund) => {
                    const i = cart.findIndex((li) => li.id === bund.id);
                    if (i > -1) indexes.push(i);
                });

                indexes.forEach((idx) => {
                    const jumlahDiambil = data?.detailBundling.find(
                        (li) => li.id === newCart[idx].id,
                    )?.jumlahYangDiambil;
                    newCart[idx] = {
                        ...newCart[idx],
                        jumlahStok:
                            Number(newCart[idx].jumlahStok) -
                            Number(jumlahDiambil),
                    };
                });
            }

            if (
                Number(newCart[index].qty) <= Number(cart[index].jumlahStok) ||
                Number(newCart[index].qty) !== null
            ) {
                set({ cart: newCart });
            }

            if (
                Number(newCart[index].qty) > Number(cart[index].jumlahStok) &&
                Number(newCart[index].qty) !== null
            ) {
                handlerErrorMaxItem();
            }
        } else {
            set((state) => ({ cart: [data, ...state.cart] }));
        }
    },
    handleUpdate: (data) => {
        const { cart } = get();
        const newCart = [...cart];
        const isIncludes = cart.findIndex((c) => c.id === data.id);

        if (isIncludes < 0) {
            newCart.push(data);
            set({ cart: newCart });
        } else {
            const index = cart.findIndex((c) => c.id === data.id);
            newCart[index] = { ...data, qty: data.qty };
            set({ cart: newCart });
        }
    },
    handleUpdateByBarcode: (data) => {
        const { cart } = get();
        const newCart = [...cart];
        const isIncludes = cart.findIndex((c) => c.sku === data.sku);

        if (isIncludes < 0) {
            newCart.push(data);
            set({ cart: newCart });
        } else {
            const index = cart.findIndex((c) => c.sku === data.sku);
            newCart[index] = data;
            set({ cart: newCart });
        }
    },
    handleRemove: (data) => {
        set((state) => ({ cart: state.cart.filter((c) => c.id !== data.id) }));
    },
    handleFaktur: (id, faktur) => {
        const { cart } = get();
        const newCart = cart;
        const indexItem = cart.findIndex((li) => li.id === id);
        newCart[indexItem].faktur = faktur;
        set({ cart: newCart });
    },
    handleFakturBundling: (idBundling, newFaktur, idSatuan) => {
        const { cart } = get();
        const newCart = cart;
        const indexBundling = cart.findIndex((li) => li.id === idBundling);
        const indexSatuan = cart[indexBundling].detailBundling.findIndex(
            (li) => li.id === idSatuan,
        );
        newCart[indexBundling].detailBundling[indexSatuan].newFaktur =
            newFaktur;
        set({ cart: newCart });
    },
    resetCart: () => set({ cart: [] }),
    handlerErrorMaxItem: () => set({ maxItem: true }),
    resetErrorMaxItem: () => set({ maxItem: false }),
    handleReset: () => {
        set({ cart: [] });
        const store = get();
        store.resetPayment();
        store.handleIsKeterangan(false);
        store.resetKeteranganBeli();
    },
});
